import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import './MemberList.css';

const MemberList = ({
  members,
  ...props
}) => {
  return (
    <ul className='channel-member-list'>
      { members.map((member, index) => {
        const { id, name, avatar } = member;
        const key = `channel-member-${name.replace(/\s/, '')}-${id}-${index}`;
        const [first, last] = name.split(' ');
        const initials = `${first[0]}${last[0]}`;

        return (
          <li key={key}>
            { avatar
              ? <img className='channel-member-avatar' src={avatar} alt='sender' />
              : <div className='channel-member-initials-avatar'>{initials}</div>
            }
            <Typography>{member.name}</Typography>
          </li>
        );
      })}
    </ul>
  );
};

MemberList.propTypes = {
  members: PropTypes.array
};

export default MemberList;
